export {
  ExclusiveMenuGateController as ExclusiveMenuGate,
  useExclusiveMenuGateModal,
} from './exclusive-menu-gate-controller';
